import { render, staticRenderFns } from "./warningRecordItem.vue?vue&type=template&id=29ae6a00&scoped=true&"
import script from "./warningRecordItem.vue?vue&type=script&lang=js&"
export * from "./warningRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./warningRecordItem.vue?vue&type=style&index=0&id=29ae6a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae6a00",
  null
  
)

export default component.exports